import { hasAnyPermission } from "../util/permissionUtils";

function useListPermission(module) {
  const permissions = [];
  const isAdmin = true;

  const includesPermission = hasAnyPermission(permissions, module);

  const hasPermission = module ? isAdmin || includesPermission : false;

  return {
    isAdmin,
    hasPermission,
    list: permissions || [],
  };
}

export default useListPermission;
